import { FidelityStateProgresses, FidelityStates, type IScene } from '@seddi/scene';
import type { GarmentExt } from '../garments/garmentTypes';
import type { GarmentFit } from './fitTypes';

export const createSceneFromFit = (
  garment: GarmentExt,
  garmentFit: GarmentFit,
): IScene | undefined => {
  const { geometrySurface } = garmentFit;
  if (!geometrySurface) {
    return;
  }

  const geometry = garment.geometry as IScene;

  // TODO: validate plastisol physically-based material for logos
  for (const logo of geometry.logos) {
    const material = logo.materials[0];
    material.params.roughness = 0.4;
    material.params.specular = 0.2;
  }

  const scene = {
    _id: garment.id,
    buttons: geometry.buttons,
    children: geometry.children,
    fabrics: geometry.fabrics,
    fidelityState: {
      progress: FidelityStateProgresses.Done,
      state: FidelityStates.TrueSeams,
    },
    logos: geometry.logos,
  } as IScene;

  const child = geometry.children.find(e => Boolean(e.components.garmentGeometry))!;
  child.components.garmentGeometry!.surfaceUrl = geometrySurface;

  return scene;
};
